import { render } from "./Tem002.vue?vue&type=template&id=26667660"
import script from "./Tem002.vue?vue&type=script&lang=js"
export * from "./Tem002.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__